import firebase from "@firebase/app";

/* =============================================================================
DB:       Realtime DB
PATH:     project.{projectId}.activities.{activityUUID}
PURPOSE:  Stores activities in a lane
============================================================================= */

// TODO: Merge with UserMsgInbox

// TODO: Reply should be a nested object

export default {

  create({ userId, activityType }) {

    const valid_types = [
      'USER_COMMENT',
      'USER_REPLY',
      'ANNOUNCEMENT',
      'LOGGED',
      'FAILED',
      'TIMER_STARTED',
      'TIMER_STOPPED',
      'TIMER_EXTENDED',
      'PICTURE_CHANGED',
      'DESC_CHANGED',
      'RULES_CHANGED',
      'USER_JOINED',
      'USER_REMOVED',
      'RIGHTS_CHANGED' ];

    if ( !valid_types.includes( activityType ) ) {
      console.warn('Invalid activity type', activityType );
    }

    let activity = {
      createdAt:      firebase.database.ServerValue.TIMESTAMP,
      userId:         userId,
      activityType:   activityType,
      text:           '',
      attachment:     '',
    };

    if ( activityType === 'LOGGED' ) {
      Object.assign( activity, {
        taskId:       null,
        taskOwnerId:  null,
        numOfLikes:   0,
        likesBy:      [] // ACHTUNG: wird nicht gespeicher in RTDB
      });
    }

    if ( activityType === 'USER_REPLY' ) {
      Object.assign( activity, {
        originalActivityId: null
      });
    }

    return activity;
  },

  fields: {
    createdAt: { validate_bolt_type: 'ServerTimestamp' },
    userId: {},
    activityType: {},
    text: {},
    attachment: {},
    taskId: {},
    numOfLikes: {},
    likesBy: {},
    "/likesBy/([a-zA-Z0-9]{28})$/": {},
    taskOwnerId: {},
    originalActivityId: {},
  }
};
